/* eslint quote-props: ["error", "as-needed", { "keywords": true, "unnecessary": false }] */

import ERROR_CODES from '@/constants/error-codes';

const TERMS_OF_USE = `
  я принимаю условия
  <a href="https://legal.motmom.com/documents/license" target="_blank"/>Пользовательского соглашения</a> и
  даю своё согласие ООО «Мо.Кард» на обработку моих персональных данных как общедоступных,
  в соответствии с Федеральным законом от 27.07.2006 года №152-ФЗ «О персональных данных»,
  на условиях и для целей, определенных
  <a href="https://legal.motmom.com/documents/privacy" target="_blank">Политикой об обработке и защите персональных данных</a>.
  Я даю свое согласие на получение информационных, рекламных и иных сообщений
`;

export default {
  authorize_title: 'АВТОРИЗАЦИЯ',
  sign_out_title: 'ВЫХОД',
  registration_title: 'РЕГИСТРАЦИЯ',
  password_restoration_title: 'ВОССТАНОВЛЕНИЕ ПАРОЛЯ',
  card_activation_title: 'АКТИВАЦИЯ <span style="color: #ccc;">МО.</sapn><span style="color: #707070;">КАРТЫ</sapn>',
  activation_title: 'АКТИВАЦИЯ',

  input_subtitle: 'Введите',
  password_change_subtitle: 'Ваш новый пароль',
  email_verification_subtitle: 'Электронная почта',
  code_verification_subtitle: {
    phone: 'Код из sms',
    email: 'Код из email',
  },
  card_activation_subtitle: 'Введите номер Мо.Карты',

  incorrect_login: {
    login: 'Неверный логин',
    email: 'Неверный email',
    phone: 'Неверный телефон',
  },

  cant_be_empty: 'Поле не может быть пустым',
  must_be_accepted: 'Необходимо принять',
  multilogin_placeholder_full: 'Номер телефона или адрес электронной почты',
  multilogin_placeholder_small: 'Номер телефона или email ',

  RatingPasswordTitle: '',
  weakRatingPasswordTitle: 'Ненадежный пароль.',
  mediumRatingPasswordTitle: 'Умеренный пароль.',
  strongRatingPasswordTitle: 'Надежный пароль.',

  changePasswordDescription: {
    title: 'Рекомендуем использовать:',
    length: 'минимум 8 символов',
    numbers: 'цифры',
    lowercase: 'буквы в нижнем регистре',
    uppercase: 'буквы в верхнем регистре',
    symbols: 'специальные символы',
  },

  sign_in: 'Войти',
  sign_out: 'Выйти',
  next: 'Продолжить',
  change: 'Изменить',
  cancel: 'Отменить',
  allow: 'Разрешить',
  restration_submit: 'Зарегистрироваться',
  get_new_code: 'Получить новый код',
  code_accepted: 'Код принят',

  second_name: 'ФАМИЛИЯ (родовое имя)',
  name: 'ИМЯ (включая среднее имя)',
  patronymic: 'ОТЧЕСТВО',
  email: 'ЭЛЕКТРОННАЯ ПОЧТА',
  phone: 'ТЕЛЕФОН',
  city: 'ГОРОД',
  country: 'СТРАНА',

  password: 'Пароль',
  forgot_password: 'Забыли пароль?',
  remember_me: 'Запомнить меня',
  correct_the_mistake: 'Исправьте ошибку',
  incorrect_login_or_password: 'Неверный логин или пароль',
  incorrect_email: 'Некорректный email',
  error_on_server: 'Произошла непредвиденная ошибка',
  need_select_date: 'Нужно выбрать дату',
  not_found: 'Совпадений не найдено',

  authorize_footer_text: {
    please_authorize: 'Пожалуйста авторизуйтесь. ',
    if_no: 'Если у Вас еще нет профиля в ',
    profile: ' , ',
    registter: ' зарегистрируйтесь ',
    or: ' или ',
    activate_card: ' активируйте свою Мо.Карту.',
  },
  email_and_phone_verification_text: 'После ввода email или номера телефона и запроса кода, Вам придёт письмо или sms с кодом, который необходимо подтвердить в будущей форме страницы',
  email_verification_text: 'После того, как Вы введете адрес электронной почты и нажмете на кнопку "Продолжить", на указанный адрес придёт письмо с кодом, который необходимо указать на следующем шаге',
  code_verification_text: 'Письмо c кодом было отправлено на представленный Вами email',
  request_new_code_avilible: 'Получить новый код можно через',
  email_verification_success_text: 'Всё отлично! ',
  email_verification_go_to_registration: 'Переходим к регистрации.',
  email_verification_go_to_restoration: 'Переходим к восстановлению.',

  card_activation_text: {
    less_two_minutes: 'Активация не займёт у Вас больше 2 минут',
    already_activated: 'Уже активировали Мо.Карту?',
    sign_in: ' Авторизуйтесь ...',
    input_activation_code: 'Введите код активации',
    your_card_has_been_activated: 'Ваша Мо.Карта - активирована!',
    wrong_code: ' - неверный код',
    code_on_card: 'Код активации находится на обороте Мо.карты',
    all_right: 'Всё отлично! Переходим к регистрации',
  },

  skip_activation: {
    link_name: 'Пропустить и зарегистрироваться без Мо.Карты',
    can_bind_card_anytime: 'Вы сможете привязать Мо.Карту в любое время в личном кабинете',
  },

  activation_registration_text: {
    success_now_register: 'Успешная активация Мо.Карты! Теперь -регистрация.',
    enter_email: 'Введите email',
  },

  authorize_success: {
    success: 'Вход успешно выполнен!',
    will_be_redirect: 'Вы будете перенаправлены на ',
  },

  sign_out_success: {
    success: 'Выход успешно выполнен!',
    will_be_redirect: 'Вы будете перенаправлены на ',
  },

  oauth2_success: {
    success: 'Разрешения предоставлены!',
    will_be_redirect: 'Вы будете перенаправлены на ',
  },

  registration_success: {
    success: 'Регистрация прошла успешно!',
    wellcome: 'Добро пожаловать в Motmom – скидки и Волшебные баллы в любимых заведениях Вашего города',
    will_be_redirect: 'Вы будете перенаправлены на',
  },

  restore_success: {
    success: 'Пароль успешно восстановлен! ',
    will_be_redirect: 'Вы будете перенаправлены на',
  },

  birthday: {
    title: 'ДАТА РОЖДЕНИЯ',
    year: 'Год',
    month: 'Месяц',
    day: 'День',
  },

  genders: {
    female: 'Ж',
    male: 'M',
  },

  authTermsOfUse: `<span style="line-height: 20px;  color: gray;">
    Нажимая кнопку «Войти», ${TERMS_OF_USE} на указанный
    при авторизации адрес электронной почты и номер телефона.</span>
  `,

  initialTermsOfUse: `<span style="line-height: 20px;  color: gray;">
    Нажимая кнопку «Продолжить», ${TERMS_OF_USE} на указанный при регистрации адрес электронной почты.</span>
  `,

  termsOfUse: `<span style="line-height: 20px;  color: gray;">
    Нажимая кнопку «Зарегистрироваться», ${TERMS_OF_USE} на указанный при регистрации адрес электронной почты.</span>
  `,

  oauth2_change_account: 'Сменить аккаунт',
  oauth2_title: {
    access: 'Разрешить приложению ',
    use_account: ' использовать вашу учетную запись?',
  },

  oauth2_policy: {
    i_confirm: 'Я даю согласие на передачу данной информации от владельца ресурса  motmom.com владельцу приложения ',
    i_also_confirm: '. Я также даю  согласие на последующую обработку персональных данных владельцем приложения ',
    i_realize: '. Я осознаю, что указанный ресурс является общедоступным источником информации, и даю согласие на обработку данных с учетом указанной особенности ресурса. Обработка персональных данных и отзыв согласия на обработку персональных данных осуществляется на условиях политик конфиденциальности ресурсов.',
    i_full_confirm: 'Я ознакомился и полностью согласен с их положениями.',
    i_conset_personal_data_transfer: ['Я даю свое согласие на передачу номера мобильного телефона и адреса электронной почты в целях получения от владельца приложения', 'информационных, рекламных и иных сообщений на указанные номер мобильного телефона и адрес электронной почты.'],
  },

  cookie_notice_text: {
    header: 'ИСПОЛЬЗОВАНИЕ ФАЙЛОВ COOKIE',
    we_use_cookie: 'Мы используем cookie-файлы, необходимые для правильной работы нашего веб-сайта. Так-же наш сайт и сторонние компании Google и Яндекс используют аналитические cookie-файлы для анализа аудитории и её поведения. подробно изучить правила использования файлов cookie можно, нажав на кнопку "Больше информации".',
    if_you_accept: 'Если вы согласны с использованием всех cookie фйлов, нажмите "Принять все". Воспользуйтесть кнопкой "Принять необходимые", если вы возражаете против обработки аналитических cookie-файлов.',
    accept_all: 'Принять все',
    accept_necessary: 'Принять необходимые',
    more_info: 'Больше информации',
  },

  cookie_policy_text: {
    use_cooki_files: 'Политика в отношении cookie-файлов',
    necessary_cookie: 'Необходимые cookie-файлы',
    policy_about_cookie_files: 'Политика в отношении cookie-файлов',
    about_necessary_cookie: 'Необходимые cookie-файлы включают основные функции, такие как безопасность и доступность. Вы можете отключить их, изменив настройки браузера, но это может повлиять на работу сайта.',
    we_use_next_necessary_cookie: 'Мы используем следующие необходимые (технические) cookie-файлы:',
    necessary_cookie_list: [
      {
        cookie: 'cookies_usage_confirmation, is_additional_cookies_accepted',
        description: 'данные cookie-файлы содержат информацию о выборе пользователя в отношении использования cookie-файлов или волю пользователя не делать выбор.',
      },
      {
        cookie: 'MOSSID',
        description: 'данные cookie-файлы содержат информацию, предназначенную для аутентификации в сервисе.',
      },
    ],
    analytics_cookie: 'Аналитические cookie-файлы',
    why_analytics: 'Мы и наши партнеры используем аналитические cookie-файлы, чтобы помочь нам улучшить наш веб-сайт, собирая и сообщая информацию о том, как вы его используете. Cookie-файлы собирают информацию таким образом, чтобы мы не могли вас идентифицировать. Информация, получаемая с использованием таких cookie-файлов, доступна третьим лицам, в частности, ресурсу Яндекс.',
    we_use_next_analytics_cookie: 'Мы используем следующие аналитические cookie-файлы:',
    analytics_cookie_list: [
      {
        cookie: 'IDE',
        description: 'данный cookie-файл содержит информацию о том, как конечный пользователь использует веб-сайт и любую рекламу, которую конечный пользователь мог видеть до посещения указанного веб-сайта.',
      },
      {
        cookie: '_ym_d',
        description: 'данный cookie-файл связан с Яндекс Метрикой и содержит дату первого посещения сайта пользователем.',
      },
      {
        cookie: '_ym_isad',
        description: 'данный cookie-файл связан с Яндекс Метрикой и определяет, включен ли у пользователя блокировщик рекламы или нет.',
      },
      {
        cookie: '_ym_uid',
        description: 'данный cookie-файл связан с Яндекс Метрикой. Этот файл cookie используется для идентификации уникальных пользователей путем присвоения случайно сгенерированного номера в качестве идентификатора клиента.',
      },
      {
        cookie: '_ym_visorc_XXXXXXXX',
        description: 'данный cookie-файл связан с Яндекс Метрикой и содержит идентификатор вебвизора и позволяет воспроизведение сеанса работать правильно.',
      },
      {
        cookie: 'i; yandexuid',
        description: 'данный cookie-файл связан с Яндекс Метрикой. Этот файл cookie позволяет различать посетителей.',
      },
      {
        cookie: 'yabs-sid',
        description: 'данный cookie-файл связан с Яндекс Метрикой. Этот файл cookie используется как идентификатор визита.',
      },
      {
        cookie: 'yp',
        description: 'данный cookie-файл связан с Яндекс Метрикой, Этот файл cookie используется как контейнер для хранения данных портала имеющий персистентный характер.',
      },
      {
        cookie: 'ys',
        description: 'данный cookie-файл связан с Яндекс Метрикой. Этот файл cookie используется как контейнер для хранения данных портала имеющий сессионный характер.',
      },
      {
        cookie: 'mda',
        description: 'данный cookie-файл связан с Яндекс Метрикой. Этот файл cookie используется для мультидоменной авторизации.',
      },
      {
        cookie: 'ymex',
        description: 'данный cookie-файл связан с Яндекс Метрикой. Этот файл cookie используются для рекламы, помогают различать пользователей, используются для анализа платформ и сайтов, для измерения и анализа веб-трафика.',
      },
      {
        cookie: 'yuidss',
        description: 'данный cookie-файл связан с Яндекс Метрикой. Этот файл cookie собирает информацию о поведении посетителей на нескольких сайтах. Эта информация используется на сайте, чтобы оптимизировать релевантность рекламы.',
      },
    ],
    more_about_cookie_policy: 'Подробную информацию о том, как мы обрабатываем cookie-файлы, вы можете найти в <a href="https://legal.motmom.com/documents/privacy" style="color: gray;"> Политике конфиденциальности.</a>',
    control_policy_of_analitycs_cookie: 'Управление параметрами аналитических cookie-файлов',
    i_agree: 'Я даю согласие на сбор аналитических cookie-файлов',
    i_degree: 'Я не даю согласие на сбор аналитических cookie-файлов',
    save_button_text: 'Сохранить мои настройки',
    select_error: 'Ничего не выбрано',
  },

  errors_messages: {
    [ERROR_CODES.MISSING_USER]: 'Пользователь отсутствует.',
    [ERROR_CODES.TOO_MANY_REQUESTS]: 'Слишком много запросов.',
    [ERROR_CODES.TOO_MANY_ATTEMPTS]: 'Превышено максимально допустимое количество попыток. Попробуйте позднее.',
    [ERROR_CODES.INVALID_UNIQUE_KEY]: 'Уникальный ключ недействителен. Попробуйте снова.',
    [ERROR_CODES.INVALID_VERIFICATION_CODE]: 'Код подтверждения неверный или истёк.',
    [ERROR_CODES.MIXED_PARAMS]: 'Смешанные параметры SMS-кода и уникального ключа.',
    [ERROR_CODES.INVALID_PASSWORD]: 'Некорректный пароль.',
    [ERROR_CODES.EMAIL_NOT_CONFIRMED]: 'Указанный почтовый адрес не подтвержден. Попробуйте восстановить пароль по номеру телефона или обратитесь в техническую поддержку.',
    [ERROR_CODES.ERROR_ATTEMPT_LIMIT]: 'Слишком много попыток, попробуйте позднее',

    [ERROR_CODES.INVALID_CARD_NUMBER]: 'Мо.Карты с таким номером не существует.',
    [ERROR_CODES.ERROR_CARD_ALREADY_ACTIVATED]: 'Мо.Карта с таким номером уже активирована.',
    [ERROR_CODES.INVALID_ACTIVATION_CODE]: 'Некорректный код активации',
    [ERROR_CODES.INVALID_SMS_CODE]: 'Некорректный код',
    [ERROR_CODES.ERROR_EMAIL_SENDING_TIMEOUT]: 'Слишком много попыток. Попробуйте позднее.',
    [ERROR_CODES.INVALID_BIRTHDAY]: 'Некорректная дата рождения',

    [ERROR_CODES.INVALID_IDENTIFIER]: 'Некорректный номер телефона или email',
    [ERROR_CODES.ERROR_INVALID_EMAIL]: 'Некорректный email',
    [ERROR_CODES.ERROR_EMAIL_EXISTS]: 'Email адрес уже занят',
    [ERROR_CODES.ERROR_INVALID_PASSWORD]: 'Некорректный пароль',
    [ERROR_CODES.UNKNOWN_SERVER_ERROR]: 'Произошла неизвестная ошибка. Обновите страницу и выполните действие заново или обратитесь в техподдержку.',

    [ERROR_CODES.INVALID_USER_OR_PASSWORD]: 'Некорректный логин или пароль',
    [ERROR_CODES.USER_NOT_FOUND]: 'Пользователь не найден',
    [ERROR_CODES.USER_IS_BLOCKED]: 'Пользователь заблокирован',
    [ERROR_CODES.PHONE_EXISTS]: 'Номер телефона уже занят',
    [ERROR_CODES.PASSWORD_RESTORATION_REQUIRED]: 'Требуется восстановление пароля',
    [ERROR_CODES.EMAIL_SENDER_ERROR]: 'Ошибка при отправке  Email с кодом восстановления. Попробуйте позднее',
    [ERROR_CODES.ERROR_EMAIL_OR_PASSWORD_NOT_FOUND]: 'Неправильный почтовый адрес или пароль',
    [ERROR_CODES.ERROR_PHONE_NUMBER_OR_PASSWORD_NOT_FOUND]: 'Неправильный номер телефона или пароль',
    [ERROR_CODES.ERROR_CARD_NUMBER_OR_PASSWORD_NOT_FOUND]: 'Неправильный код карты или пароль',
    [ERROR_CODES.ERROR_INVALID_USERNAME]: 'Некорректное имя пользователя',
  },

  country_name: {
    'AU': 'Австралия',
    'AT': 'Австрия',
    'AZ': 'Азербайджан',
    'AX': 'Аландские острова',
    'AL': 'Албания',
    'DZ': 'Алжир',
    'VI': 'Виргинские Острова',
    'AS': 'Американское Самоа',
    'AI': 'Ангилья',
    'AO': 'Ангола',
    'AD': 'Андорра',
    'AQ': 'Антарктида',
    'AG': 'Антигуа и Барбуда',
    'AR': 'Аргентина',
    'AM': 'Армения',
    'AW': 'Аруба',
    'AF': 'Афганистан',
    'BS': 'Багамы',
    'BD': 'Бангладеш',
    'BB': 'Барбадос',
    'BH': 'Бахрейн',
    'BZ': 'Белиз',
    'BY': 'Беларусь',
    'BE': 'Бельгия',
    'BJ': 'Бенин',
    'BM': 'Бермуды',
    'BG': 'Болгария',
    'BO': 'Боливия',
    'BQ': 'Бонэйр, Синт-Эстатиус и Саба',
    'BA': 'Босния и Герцеговина',
    'BW': 'Ботсвана',
    'BR': 'Бразилия',
    'IO': 'Британская территория в Индийском океане',
    'VG': 'Виргинские Острова',
    'BN': 'Бруней',
    'BF': 'Буркина-Фасо',
    'BI': 'Бурунди',
    'BT': 'Бутан',
    'VU': 'Вануату',
    'VA': 'Ватикан',
    'GB': 'Великобритания',
    'HU': 'Венгрия',
    'VE': 'Венесуэла',
    'UM': 'Внешние малые острова',
    'TL': 'Восточный Тимор',
    'VN': 'Вьетнам',
    'GA': 'Габон',
    'HT': 'Гаити',
    'GY': 'Гайана',
    'GM': 'Гамбия',
    'GH': 'Гана',
    'GP': 'Гваделупа',
    'GT': 'Гватемала',
    'GF': 'Гвиана',
    'GN': 'Гвинея',
    'GW': 'Гвинея-Бисау',
    'DE': 'Германия',
    'GG': 'Гернси',
    'GI': 'Гибралтар',
    'HN': 'Гондурас',
    'HK': 'Гонконг',
    'GD': 'Гренада',
    'GL': 'Гренландия',
    'GR': 'Греция',
    'GE': 'Грузия',
    'GU': 'Гуам',
    'DK': 'Дания',
    'JE': 'Джерси',
    'DJ': 'Джибути',
    'DM': 'Доминика',
    'DO': 'Доминиканская Республика',
    'CD': 'Демократическая Республика Конго',
    'EG': 'Египет',
    'ZM': 'Замбия',
    'EH': 'САДР',
    'ZW': 'Зимбабве',
    'IL': 'Израиль',
    'IN': 'Индия',
    'ID': 'Индонезия',
    'JO': 'Иордания',
    'IQ': 'Ирак',
    'IR': 'Иран',
    'IE': 'Ирландия',
    'IS': 'Исландия',
    'ES': 'Испания',
    'IT': 'Италия',
    'YE': 'Йемен',
    'CV': 'Кабо-Верде',
    'KZ': 'Казахстан',
    'KY': 'Острова Кайман',
    'KH': 'Камбоджа',
    'CM': 'Камерун',
    'CA': 'Канада',
    'QA': 'Катар',
    'KE': 'Кения',
    'CY': 'Кипр',
    'KG': 'Киргизия',
    'KI': 'Кирибати',
    'TW': 'Китайская Республика',
    'KP': 'КНДР',
    'CN': 'КНР',
    'CC': 'Кокосовые острова',
    'CO': 'Колумбия',
    'KM': 'Коморы',
    'CR': 'Коста-Рика',
    'CI': 'Кот-д’Ивуар',
    'CU': 'Куба',
    'KW': 'Кувейт',
    'CW': 'Кюрасао',
    'LA': 'Лаос',
    'LV': 'Латвия',
    'LS': 'Лесото',
    'LR': 'Либерия',
    'LB': 'Ливан',
    'LY': 'Ливия',
    'LT': 'Литва',
    'LI': 'Лихтенштейн',
    'LU': 'Люксембург',
    'MU': 'Маврикий',
    'MR': 'Мавритания',
    'MG': 'Мадагаскар',
    'YT': 'Майотта',
    'MO': 'Макао',
    'MW': 'Малави',
    'MY': 'Малайзия',
    'ML': 'Мали',
    'MV': 'Мальдивы',
    'MT': 'Мальта',
    'MA': 'Марокко',
    'MQ': 'Мартиника',
    'MH': 'Маршалловы Острова',
    'MX': 'Мексика',
    'FM': 'Микронезия',
    'MZ': 'Мозамбик',
    'MD': 'Молдавия',
    'MC': 'Монако',
    'MN': 'Монголия',
    'MS': 'Монтсеррат',
    'MM': 'Мьянма',
    'NA': 'Намибия',
    'NR': 'Науру',
    'NP': 'Непал',
    'NE': 'Нигер',
    'NG': 'Нигерия',
    'NL': 'Нидерланды',
    'NI': 'Никарагуа',
    'NU': 'Ниуэ',
    'NZ': 'Новая Зеландия',
    'NC': 'Новая Каледония',
    'NO': 'Норвегия',
    'AE': 'ОАЭ',
    'OM': 'Оман',
    'BV': 'Остров Буве',
    'IM': 'Остров Мэн',
    'CK': 'Острова Кука',
    'NF': 'Остров Норфолк',
    'CX': 'Остров Рождества',
    'PN': 'Острова Питкэрн',
    'SH': 'Острова Святой Елены',
    'AC': 'Остров Вознесения',
    'PK': 'Пакистан',
    'PW': 'Палау',
    'PS': 'Государство Палестина',
    'PA': 'Панама',
    'PG': 'Папуа — Новая Гвинея',
    'PY': 'Парагвай',
    'PE': 'Перу',
    'PL': 'Польша',
    'PT': 'Португалия',
    'PR': 'Пуэрто-Рико',
    'CG': 'Республика Конго',
    'KR': 'Республика Корея',
    'RE': 'Реюньон',
    'RU': 'Российская Федерация',
    'RW': 'Руанда',
    'RO': 'Румыния',
    'SV': 'Сальвадор',
    'WS': 'Самоа',
    'SM': 'Сан-Марино',
    'ST': 'Сан-Томе и Принсипи',
    'SA': 'Саудовская Аравия',
    'SZ': 'Свазиленд',
    'MK': 'Северная Македония',
    'MP': 'Северные Марианские Острова',
    'SC': 'Сейшельские Острова',
    'BL': 'Сен-Бартелеми',
    'MF': 'Сен-Мартен',
    'PM': 'Сен-Пьер и Микелон',
    'SN': 'Сенегал',
    'VC': 'Сент-Винсент и Гренадины',
    'KN': 'Сент-Китс и Невис',
    'LC': 'Сент-Люсия',
    'RS': 'Сербия',
    'SG': 'Сингапур',
    'SX': 'Синт-Мартен',
    'SY': 'Сирия',
    'SK': 'Словакия',
    'SI': 'Словения',
    'SB': 'Соломоновы Острова',
    'SO': 'Сомали',
    'SD': 'Судан',
    'SR': 'Суринам',
    'US': 'США',
    'SL': 'Сьерра-Леоне',
    'TJ': 'Таджикистан',
    'TH': 'Таиланд',
    'TZ': 'Танзания',
    'TC': 'Теркс и Кайкос',
    'TG': 'Того',
    'TK': 'Токелау',
    'TO': 'Тонга',
    'TT': 'Тринидад и Тобаго',
    'TV': 'Тувалу',
    'TN': 'Тунис',
    'TM': 'Туркмения',
    'TR': 'Турция',
    'UG': 'Уганда',
    'UZ': 'Узбекистан',
    'UA': 'Украина',
    'WF': 'Уоллис и Футуна',
    'UY': 'Уругвай',
    'FO': 'Фареры',
    'FJ': 'Фиджи',
    'PH': 'Филиппины',
    'FI': 'Финляндия',
    'FK': 'Фолклендские острова',
    'FR': 'Франция',
    'PF': 'Французская Полинезия',
    'TF': 'Французские Южные и Антарктические Территории',
    'HM': 'Херд и Макдональд',
    'HR': 'Хорватия',
    'CF': 'ЦАР',
    'TD': 'Чад',
    'ME': 'Черногория',
    'CZ': 'Чехия',
    'CL': 'Чили',
    'CH': 'Швейцария',
    'SE': 'Швеция',
    'SJ': 'Шпицберген и Ян-Майен',
    'LK': 'Шри-Ланка',
    'EC': 'Эквадор',
    'GQ': 'Экваториальная Гвинея',
    'ER': 'Эритрея',
    'EE': 'Эстония',
    'ET': 'Эфиопия',
    'ZA': 'ЮАР',
    'GS': 'Южная Георгия и Южные Сандвичевы Острова',
    'SS': 'Южный Судан',
    'JM': 'Ямайка',
    'JP': 'Япония',
    'XK': 'Косово',
  },
};
